/** Footer "Our Products" — v2 catalog category URLs. */
export const FOOTER_PRODUCT_LINKS = [
  { label: 'Eggs', path: '/v2/catalog?category=Eggs' },
  { label: 'Pickles', path: '/v2/catalog?category=Pickles' },
  { label: 'Mutton', path: '/v2/catalog?category=Mutton' },
  { label: 'BTB Chicken', path: '/v2/catalog?category=BTB+Chicken' },
  { label: 'Country Chicken (Natukodi)', path: '/v2/catalog?category=Country+Chicken+%28Natukodi%29' },
  { label: 'All Products', path: '/v2/catalog' },
];

/** Know Us — v2 static pages (no About Us). */
export const KNOW_US_LINKS = [
  { label: 'Our Stores', path: '/v2/stores' },
  { label: 'Contact Us', path: '/v2/contact' },
  { label: 'Terms And Conditions', path: '/v2/terms' },
  { label: 'Privacy Policy', path: '/v2/privacy' },
  { label: 'Cancellation / Refund Policy', path: '/v2/refund' },
];

export const SOCIAL_LINKS = [
  { label: 'Facebook', url: 'https://www.facebook.com/Countrychickenco/' },
  { label: 'Instagram', url: 'https://www.instagram.com/countrychickenco/' },
  { label: 'WhatsApp', url: 'https://whatsapp.com' },
  { label: 'LinkedIn', url: 'https://www.linkedin.com/company/countrychickenco/' },
];
